/**
 * 系统设置，偏向于用户，重要性不强
 * @creator francklin
 * @created 2021.09.13
 */

import _ from 'lodash'
import defaultSettings from '../config/settings.env.js'

const state = _.extend(defaultSettings.common,defaultSettings[_APP_.ENV]);

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: false,
  state,
  mutations,
  actions
}

